export default __webpack_public_path__ + "navigation-examples-waypoint-arrival-screen-thumbnail-480-3511a6b5a49bf986f0f7db1e5bbaaacd.png";